import { red } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';

// A custom theme for this app
const theme = createTheme({
  palette: {
    primary: {
      main: '#1EB0BC',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#19857b',
    },

    error: {
      main: red.A400,
    },
  },
  typography: {
    htmlFontSize: 10
  },
  overrides: {
    MuiCssBaseline: {
      "@global": {
        html: {
          fontSize: "62.5%"
        }
      }
    }
  }
});

export default theme;
